import React from "react";
import { Typography, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import styles from "./ApplicationFormModal.module.scss";

/**
 * Right panel: Fill Manually – skip OCR and enter details by hand.
 */
export default function ManualEntryPanel({ onEnterDetails, disabled }) {
  return (
    <div className={styles.panel}>
      <Typography className={styles.panelTitle}>Fill Manually</Typography>
      <Typography className={styles.panelDescription}>
        Skip OCR and manually enter the student's application details.
      </Typography>
      <Button
        variant="outlined"
        className={styles.panelButton}
        startIcon={<EditIcon />}
        onClick={onEnterDetails}
        disabled={disabled}
      >
        Enter Details
      </Button>
    </div>
  );
}
